import moment from 'moment'
import downloadjs from 'downloadjs'
import { fetchWithToken } from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'

export const TracabiliteService = {
  get(clientId) {
    return fetchWithToken(`${config().tracabiliteService}/?clientid=${clientId}`, { method: 'GET' })
      .then((response) => response.json())
  },
  print(img, date) {
    return fetchWithToken(`${config().imagePdfService}`, {
      method: 'POST',
      body: JSON.stringify({
        img,
        date,
      }),
    }).then((response) => response.blob())
      .then((file) => {
        downloadjs(file, `traca-${date}.pdf`)
      })
  },
  getByDate(context, clientId, date = moment().format('YYYY-MM-DD')) {
    return fetchWithToken(`${config(context).tracabiliteService}/?clientid=${clientId}&date=${date}`, { method: 'GET' })
      .then((response) => response.json())
  },
  getCalendar(context, clientId) {
    return fetchWithToken(`${config(context).tracabiliteService}/calendar?clientid=${clientId}`, { method: 'GET' })
      .then((response) => response.json())
  },
  getCategories(context) {
    return fetchWithToken(`${config(context).tracabiliteService}/categories`, { method: 'GET' })
      .then((response) => response.json())
  },
  getImg(context, img) {
    return `${config(context).tracabiliteService}/${img}`
  },
  getHygieneImg(context, img) {
    return `${config(context).tracabiliteService}/hygiene/${img}`
  },
  getRemarquesImg(img) {
    return `${config().tracabiliteService}/remarques/${img}`
  },
}
